(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchaseItemLotDialogController', PurchaseItemLotDialogController);

    PurchaseItemLotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchaseItemLot', 'PurchaseItem'];

    function PurchaseItemLotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchaseItemLot, PurchaseItem) {
        var vm = this;
        vm.purchaseItemLot = entity;
        vm.purchaseItems = PurchaseItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchaseItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchaseItemLot.id !== null) {
                PurchaseItemLot.update(vm.purchaseItemLot, onSaveSuccess, onSaveError);
            } else {
                PurchaseItemLot.save(vm.purchaseItemLot, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
